import { render } from "./AutumnSliderSection.vue?vue&type=template&id=2e681fb2&scoped=true"
import script from "./AutumnSliderSection.vue?vue&type=script&lang=js"
export * from "./AutumnSliderSection.vue?vue&type=script&lang=js"

import "./AutumnSliderSection.vue?vue&type=style&index=0&id=2e681fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e681fb2"]])

export default __exports__